import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./compatibility.html";
import { selectCompatibility, WireI18n } from '~/modules/stores/i18nStore';
const defaultProps = {
  compatibleWith: [],
  requiredProducts: [],
  salesforceEditions: [],
  additionalRequirements: ''
};
class Compatibility extends LightningElement {
  constructor(...args) {
    super(...args);
    this.compatibilityProps = defaultProps;
    this.
    // @ts-expect-error * Automated Type Error Fix
    labels = void 0;
    // @ts-expect-error * Automated Type Error Fix
    this.requireContentsTooltip = null;
    // @ts-expect-error * Automated Type Error Fix
    this.compatibilityTooltip = null;
  }
  i18nCallback(i18n) {
    this.requireContentsTooltip = i18n.listingDetails.tooltipsText.requireContentsTooltip;
    this.compatibilityTooltip = i18n.listingDetails.tooltipsText.compatibilityToolip;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Compatibility, {
  publicProps: {
    compatibilityProps: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectCompatibility
        };
      }
    },
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["requireContentsTooltip", "compatibilityTooltip"]
});
const __lwc_component_class_internal = _registerComponent(Compatibility, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;